module.exports = __webpack_public_path__ + "static/media/man.84c8365d.jpg";